<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی ذی نفعان چارچوب میچل  </h2>
              <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
            </div>
            <hr class="mb-3">
            <center v-if="!status">
              {{ error }}
            </center>
            <div v-if="status" style="height: auto; margin-bottom: 10vw;">
              <div :style="`transform: translateX(${flow_x}vw)`"
                   class="d-flex align-items-center justify-content-center mt-5 position-relative translate">
                <div class="rounded-circle circle"></div>
                <div class="rounded-circle circle"></div>
                <div class="rounded-circle circle"></div>
                <span @click.prevent="showModal(1)" class="span_1 span position-absolute">ساکت</span>
                <span @click.prevent="showModal(2)" class="span_2 span position-absolute">مسلط</span>
                <span @click.prevent="showModal(3)" class="span_3 span position-absolute">قطعی</span>
                <span @click.prevent="showModal(4)" class="span_4 span position-absolute">خطرناک</span>
                <span @click.prevent="showModal(5)" class="span_5 span position-absolute">محتاط</span>
                <span @click.prevent="showModal(6)" class="span_6 span position-absolute">وابسته</span>
                <span @click.prevent="showModal(7)" class="span_7 span position-absolute">متقاضی</span>
                <span class="span_8 span position-absolute">قدرت</span>
                <span class="span_9 span position-absolute">مشروعیت</span>
                <span class="span_10 span position-absolute">فوریت</span>
              </div>

            </div>
            <div v-if="status_flow" style="width: 40vw; position:absolute; top: 7vw;">
              <div class="d-flex justify-content-between align-items-center translate2">
                <p style="font-size: 1vw">{{ type_name }}</p>
                <button @click.prevent="resetModal" class="btn btn-primary btn-submit-1">برگشت</button>
              </div>
              <table class="table table-striped w-100">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  <th>عنوان</th>
                </tr>
                </thead>
                <tr v-if="items_table.length" v-for="(item,index) in items_table">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.title }}</td>
                </tr>
                <tr v-else>
                  <td colspan="2">موردی یافت نشد</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import BeneficiaryRow from "@/components/beneficiary/BeneficiaryRowMitchell.vue";
import {useToast} from "vue-toastification";
import router from "@/router";

const toast = useToast();

export default {
  name: "beneficiary_id_order_by",
  components: {Sidebar, Splash, BeneficiaryRow},
  data() {
    return {
      averages: [],
      items: [],
      status: false,
      error: 'دوره ای برای ارزیابی ذی نفعان تعریف نشده است.',
      all_beneficiary: [],
      updated_beneficiaries: [],
      silent: [],
      dominates: [],
      certain: [],
      cautious: [],
      dangerous: [],
      dependents: [],
      applicants: [],
      items_table: [],
      flow_x: '',
      type_name: '',
      status_flow: false,
    };
  },
  methods: {
    resetModal(){
      this.status_flow=false
      this.flow_x = 0

    },

    showModal(type) {
      this.flow_x = -22
      this.status_flow = true

      let item = parseInt(type)
      if (item === 1) {
        this.items_table = this.silent
        this.type_name = 'ساکت'
        this.type_name+='(قدرت)'
      } else if (item === 2) {
        this.items_table = this.dominates
        this.type_name = 'مسلط'
        this.type_name+='(قدرت،مشروعیت)'


      } else if (item === 3) {
        this.items_table = this.certain
        this.type_name = 'قطعی'
        this.type_name+='(قدرت،مشروعیت،فوریت)'

      } else if (item === 4) {
        this.items_table = this.cautious
        this.type_name = 'خطرناک'
        this.type_name+='(قدرت،فوریت)'

      } else if (item === 5) {
        this.items_table = this.dangerous
        this.type_name = 'محتاط'
        this.type_name+='(مشروعیت)'

      } else if (item === 6) {
        this.items_table = this.dependents
        this.type_name = 'وابسته'
        this.type_name+='(مشروعیت،فوریت)'

      } else if (item === 7) {
        this.items_table = this.applicants
        this.type_name = 'متقاضی'
        this.type_name+='(فوریت)'

      }
    },
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryPeriod/show`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.status = false;
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            if (response.item) {
              this.status = true;
              this.all_beneficiaryMethod();
            }

          })
          .catch();
    },
    all_beneficiaryMethod() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/all_for_mitchell_aggregated`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            this.all_beneficiary = [...response.all];
            this.averages = response.averages;
            if (response.silent) {
              this.silent = [...response.silent]

            }
            if (response.dominates) {
              this.dominates = [...response.dominates]

            }
            if (response.certain) {
              this.certain = [...response.certain]

            }
            if (response.cautious) {
              this.cautious = [...response.cautious]

            }
            if (response.dangerous) {
              this.dangerous = [...response.dangerous]

            }
            if (response.dependents) {
              this.dependents = [...response.dependents]

            }
            if (response.applicants) {
              this.applicants = [...response.applicants]

            }

          })
          .catch();
    },
    updateBeneficiary(updatedItem) {
      const index = this.updated_beneficiaries.findIndex(item => item.id === updatedItem.id);
      if (index !== -1) {
        this.updated_beneficiaries[index] = updatedItem;
      } else {
        this.updated_beneficiaries.push(updatedItem);
      }
    },
    saveAll() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({items: this.updated_beneficiaries}),
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary_mitchell/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error);
              return;
            }
            toast.success('داده‌ها با موفقیت ذخیره شدند.');
          })
          .catch(error => {
            toast.error('خطایی رخ داده است.');
          });
    },
    checkIsMother() {
      if (this.is_mother) {
        router.push('/pishkhan')
      }


      return;
    }
  },
  mounted() {
    this.checkIsMother();
    this.all();
  }
};
</script>

<style scoped lang="scss">
.translate2{
  transition: all ease 2s;
}.translate{
  transition: all ease 500ms;
}
.span {
  font-size: 1vw;
  font-weight: 900;
  cursor: pointer;
  transition: all ease 500ms;

  &:hover {
    border-bottom: 0.1vw solid #000;
  }
}

.span_1 {
  left: 25vw;
}

.span_2 {
  left: 35vw;
  top: 5vw;
}

.span_3 {
  left: 35vw;
  top: 10vw;
}

.span_4 {
  left: 28vw;
  top: 15vw;
}

.span_5 {
  left: 42vw;
  top: 4vw;
}

.span_6 {
  left: 40vw;
  top: 14vw;
}

.span_7 {
  left: 34vw;
  top: 20vw;
}

.span_8 {
  left: 22vw;
  top: 0;
  position: relative;

  &:after {
    position: absolute;
    top: 2vw;
    right: -1vw;
    content: '';
    width: 2vw;
    height: 0.1vw;
    background-color: #222;
    transform: rotate(45deg);
  }
}

.span_9 {
  left: 47vw;
  top: 0;
  position: relative;

  &:after {
    position: absolute;
    top: 2.5vw;
    right: 2vw;
    content: '';
    width: 2vw;
    height: 0.1vw;
    background-color: #222;
    transform: rotate(-45deg);
  }
}

.span_10 {
  left: 44vw;
  bottom: -8vw;
  position: relative;

  &:after {
    position: absolute;
    top: 0.1vw;
    right: 3vw;
    content: '';
    width: 2vw;
    height: 0.1vw;
    background-color: #222;
    transform: rotate(45deg);
  }
}

.circle {
  background-color: rgba(#5e67fc, 0.2);
  width: 18vw;
  height: 18vw;
  border: 0.1vw solid #222;

  &:nth-child(1) {
    transform: translateX(-14vw);
  }

  &:nth-child(2) {
    transform: translateY(8vw);
  }

  &:nth-child(3) {
    transform: translateX(14vw);
  }
}

.row {
  padding: .5vw;
}

h3 {
  font-size: 1.5vw !important;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}
</style>
